module.exports = __webpack_public_path__ + "img/system-up.966783d2.svg";